import React, { Component } from 'react';

import { contentTypes, contentTypeRoutes } from '../../common/Constants';
import SiteConstants from '../../common/SiteConstants/SiteConstants';
import { Category } from '../DetailsTypes';

import './stock-item-seo-links.less';

interface Props {
  title: string;
  categories: Category[];
}

export default class StockItemCategoryLinks extends Component<Props> {
  render() {
    if (!this.props.categories || this.props.categories.length < 1) {
      return null;
    }

    const title = this.props.title || 'Categories';

    return (
      <div id={title} className="stockItemSeoLinks">
        <h6 className="stockItemSeoLinks-subHeader">{title}</h6>

        {this.renderLinks(this.buildCategoryLinks())}
      </div>
    );
  }

  renderLinks(linkSet) {
    return (
      <p className="stockItemSeoLinks-links">
        {linkSet.map((linkInfo) => (
          <span
            className="stockItemSeoLinks-link"
            data-selenium-value={linkInfo.title}
            key={linkInfo.id}
          >
            <a href={linkInfo.url}>{linkInfo.title}</a>
          </span>
        ))}
      </p>
    );
  }

  buildCategoryLinks() {
    return this.props.categories.map((category) => {
      const mediaTypeRoute = this.getMediaTypeRoute(category.searchType);

      return {
        id: category.id,
        url:
          SiteConstants.getInstance().getSearchRoute() +
          (!mediaTypeRoute
            ? ''
            : `?media-type=${encodeURIComponent(mediaTypeRoute)}`) +
          `&categories=${encodeURIComponent(category.urlId)}`,
        title: category.name,
      };
    });
  }

  //TODO This will probably need to change after fixing OMFG-35
  getMediaTypeRoute(searchType) {
    switch (searchType) {
      case 'photograph':
        return contentTypeRoutes.PHOTOS;
      case 'sfx':
        return contentTypeRoutes.SOUND_EFFECT;
      case contentTypes.VECTOR:
        return contentTypeRoutes.VECTORS;
      case contentTypes.ILLUSTRATION:
        return contentTypeRoutes.ILLUSTRATIONS;
      default:
        return searchType;
    }
  }
}
